import React, { useEffect, useState } from "react";
import {
  fetchEntityFollowers,
  removeEntityFollower,
} from "../Community/communitySocialApi";
import "./ContentStudio.css";

/**
 * Workspace follower management — list, search, remove.
 * Message / export remain future.
 */
function FollowersWorkspacePanel({ entityType, entityId, entityLabel }) {
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [followers, setFollowers] = useState([]);
  const [total, setTotal] = useState(0);

  const load = async (search) => {
    if (!entityType || !entityId) {
      setError("Entity context required");
      setLoading(false);
      return;
    }
    setLoading(true);
    setError("");
    const res = await fetchEntityFollowers({
      type: entityType,
      id: entityId,
      q: search != null ? search : q,
      page: 1,
      per_page: 50,
    });
    if (res.error) {
      setError(res.message || "Unable to load followers");
      setFollowers([]);
      setTotal(0);
    } else {
      setFollowers(res.followers || []);
      setTotal(res.total || 0);
    }
    setLoading(false);
  };

  useEffect(() => {
    load("");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entityType, entityId]);

  const onRemove = async (userId) => {
    if (!window.confirm("Remove this follower?")) return;
    const res = await removeEntityFollower({
      type: entityType,
      id: entityId,
      userId,
    });
    if (!res.error) {
      load(q);
    } else {
      setError(res.message || "Unable to remove follower");
    }
  };

  return (
    <div className="cstudio followers-workspace">
      <header className="cstudio__header" style={{ marginBottom: "1rem" }}>
        <div>
          <p className="cstudio-eyebrow">Audience</p>
          <h1>Followers{entityLabel ? ` · ${entityLabel}` : ""}</h1>
          <p className="cstudio-muted">{total} follower{total === 1 ? "" : "s"}</p>
        </div>
      </header>

      <form
        className="cstudio-toolbar"
        onSubmit={(e) => {
          e.preventDefault();
          load(q);
        }}
      >
        <input
          type="search"
          placeholder="Search by name or email"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          aria-label="Search followers"
        />
        <button type="submit" className="cstudio-btn">
          Search
        </button>
      </form>

      {loading ? <p className="cstudio-muted">Loading…</p> : null}
      {error ? <p className="cstudio-error">{error}</p> : null}

      {!loading && !error ? (
        <ul className="cstudio-list">
          {followers.map((f) => (
            <li key={f.id || f.user_id}>
              <div>
                <strong>{f.name || `User #${f.user_id}`}</strong>
                <div className="cstudio-muted">
                  {f.email || ""}
                  {f.followed_at
                    ? ` · since ${new Date(f.followed_at).toLocaleDateString()}`
                    : ""}
                </div>
              </div>
              <div className="cstudio-toolbar" style={{ gap: 8 }}>
                {f.profile_path ? (
                  <a className="cstudio-btn cstudio-btn--ghost" href={f.profile_path}>
                    Profile
                  </a>
                ) : null}
                <button
                  type="button"
                  className="cstudio-btn cstudio-btn--ghost"
                  onClick={() => onRemove(f.user_id)}
                >
                  Remove
                </button>
              </div>
            </li>
          ))}
          {!followers.length ? (
            <li>
              <span className="cstudio-muted">No followers yet.</span>
            </li>
          ) : null}
        </ul>
      ) : null}
    </div>
  );
}

export default FollowersWorkspacePanel;
